'use client';
import React from 'react';
import cn from '@utils/cn';
import { TestimonialsType } from '@lib/sanity/queries/modules/testimonials/types';
import { GridColFullWidth } from '@constants/layout';
import HeaderCenter from '@components/shared/Header/HeaderCenter';
import Anchor from '@ui/Anchor/Anchor';
import Text, { TextVariant } from '@ui/Text/Text';
import PortableText from '@ui/Text/PortableText';

type Props = {
  data: TestimonialsType;
  visuals?: Record<string, React.ReactNode>;
};

export default function TestimonialsMasonryClient({ data, visuals }: Props) {
  if (!data) {
    return null;
  }

  return (
    <div
      className={cn('z-10 mx-auto flex w-full flex-col items-center justify-center gap-8 md:gap-16', GridColFullWidth)}
    >
      <HeaderCenter {...data} />

      <ul className="h-full columns-1 break-inside-avoid-column gap-8 md:columns-2 lg:columns-3">
        {data.testimonials?.length &&
          data.testimonials.map((testimonial, index) => (
            <li key={index} className="break-inside-avoid-column pb-8">
              <div
                style={{
                  boxShadow: `0.822px 2.216px 10.348px 0px rgba(0, 0, 0, 0.03),
                                        3.884px 10.474px 40.452px 0px rgba(0, 0, 0, 0.04)`,
                }}
                className={
                  'bg-background flex h-auto flex-col' +
                  ' h-auto items-start justify-between gap-3 rounded-2xl border p-8'
                }
              >
                <Anchor
                  aria-label={testimonial.company?.text?.value ?? ''}
                  href={testimonial.company?.url ?? undefined}
                  className="flex justify-start gap-3"
                >
                  {testimonial.logo?._id && visuals?.[testimonial.logo._id]}
                  <div className="flex flex-col justify-center">
                    <Text content={testimonial.name?.value} variant={TextVariant.SubtitleSM} />
                    <Text content={testimonial.company?.text?.value} variant={TextVariant.TextBodySM} />
                  </div>
                </Anchor>
                <PortableText content={testimonial.quote} variant={TextVariant.TextBodyMD} />
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
}
